import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateUserDocument } from './create.generated';

export const useCreateUser = (options: ApiOptions<typeof CreateUserDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateUserDocument, {
    ...useNotifications(CreateUserDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.users.create_success'),
    }),
    ...options,
  });
};
